export default payload => {
  const homeClaimId = payload?.data?.create_home_claim?.id;
  const errors = payload?.data?.create_home_claim?.errors;

  const data = homeClaimId ? { id: homeClaimId } : null;

  return { data, errors };
};
